import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Team',
  meta: {
    icon: 'fa-space-shuttle',
    expanded: false,
    roles: Global.ALL_ROLE
  },
  path: '/allTeam',
  component: lazyLoading('team/AllTeam')
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/team.js